import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { BannerService } from '../../shared/services/banner.service';
import { Subject, takeUntil } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CarouselModule } from 'primeng/carousel';
import { AfraImageComponent } from '../../shared/components/afra-image/afra-image.component';

@Component({
  selector: 'app-campaign-banner',
  templateUrl: './campaign-banner.component.html',
  styleUrls: ['./campaign-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CarouselModule, AfraImageComponent],
  standalone: true,
})
export class CampaignBannerComponent implements OnInit, OnDestroy {
  private readonly bannerService = inject(BannerService);
  private readonly destroy$ = new Subject<void>();
  private isMobile = signal(window.innerWidth < 768);
  showCampaignBanner: boolean = environment.showCampaignBanner;
  slides = signal<Array<{ id: string; alt: string; href: string }>>([]);
  items = signal<any>(['hello 1', ' hello 2']);
  ngOnInit() {
    if (!this.showCampaignBanner) {
      return;
    }
    this.loadSlides();
    window.addEventListener('resize', this.handleResize);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    window.removeEventListener('resize', this.handleResize);
  }

  private handleResize = () => {
    const wasMobile = this.isMobile();
    this.isMobile.set(window.innerWidth < 768);
    if (wasMobile !== this.isMobile()) {
      this.loadSlides();
    }
  };

  private loadSlides() {
    this.bannerService
      .getBanners()
      .pipe(takeUntil(this.destroy$))
      .subscribe((response) => {
        const isMobile = this.isMobile();
        const slides = response.results
          .filter((b) => b.is_active)
          .map((b) => ({
            id: isMobile ? b.mobile_banner_id : b.banner_id,
            alt: b.title,
            href: b.link,
          }));

        this.slides.set(slides);
      });
  }

  onSlideClick(slide: { href: string }) {
    if (slide.href) {
      window.open(slide.href, '_blank');
    }
  }
}
